/**
 * For security reasons, keep the LocalStorage keys hashed.
 */

export enum LocalStorage {
  SHOW_PASSWORD = 'cuwKDxOwex'
}
